'use strict'

var Marionette = require('marionette')
var App = require('app')
var _ = require('lodash')
// var TabBehavior = require('src/behaviors/tabs')
var DialogComponent = require('src/components/dialog-view')
var Radio = require('backbone.radio');

var notifyChannel = Radio.channel('notify');


// -- Group editor

var ListItemView = Marionette.View.extend({
  template: require('./templates/edit-group_item.html'),
  tagName: 'li',
  events: {
    'click': 'onSelect'
  },
  onSelect: function (ev) {

    this.model.set('selected', !this.model.get('selected'))

    // notify the system about the selected item
    notifyChannel.trigger('groups:item:selected', {
      deviceListType:this.options.deviceListType,
      model:this.model
    });
    
  },
  modelEvents: {
    'change': 'render'
  }
})

var EmptyListItemView = Marionette.View.extend({
  template: _.template('No devices found...')
})

var ListView = Marionette.CollectionView.extend({
  tagName: 'ul',
  className: 'list-unstyled',
  childView: ListItemView,
  emptyView: EmptyListItemView,
  childViewOptions: function(model, index) {
    return {
      deviceListType: this.options.type, 
    }
  }
})

// module.exports.Layout = Layout
module.exports.DevicesListView = ListView

// -- Dialog Body ---------------------------
var dialogBody = DialogComponent.Body.extend({
  initialize: function() {
    this.listenTo(notifyChannel, 'groups:item:selected', this.onItemSelect);
  },
  events: {
    'click .js-add-devices': 'onAddDevices',
    'click .js-remove-devices': 'onRemoveDevices',
    'change .js-selected-device-type': 'onTypeChange',
    'keyup .js-filter': 'onFilterChange',
    'change .js-select-all-available': 'onSelectAllAvailableChange',
    'change .js-select-all-attached': 'onSelectAllAttachedChange'
  },
  tagName: 'div',
  template: require('./templates/edit.html'),
  regions: {
    devicesListRegion: '.group-devices__region',
    devicesSelectRegion: '.devices-selection__region',
    availableDevicesRegion: '.group-edit__available-devices',
    selectedDevicesRegion: '.group-edit__selected-devices'
  },
  onItemSelect: function(message) {
    // deselect the 'select all' checkbox when an item is selected
    let allAvailableEl = this.el.querySelector('.js-select-all-available')
    let allAttachedEl = this.el.querySelector('.js-select-all-attached')

    if(message.deviceListType === 'available-devices') {
      allAvailableEl.checked = false;
    } else if (message.deviceListType === 'attached-devices') {
      allAttachedEl.checked = false;
      
    }
  },
  onSelectAllAvailableChange: function (ev) {
    this.triggerMethod('select-all-available', this.view, ev.currentTarget.checked)
  },
  onSelectAllAttachedChange: function (ev) {
    this.triggerMethod('select-all-attached', this.view, ev.currentTarget.checked)
  },
  onFilterChange: function (ev) {
    this.triggerMethod('filter-change', ev.currentTarget.value)
  },
  onAddDevices: function (ev) {
    this.triggerMethod('add-devices', this.view)
  },
  onRemoveDevices: function (ev) {
    this.triggerMethod('remove-devices', this.view)
  },
  onTypeChange: function (ev) {
    this.model.set('type', ev.currentTarget.value, {silent:true})
    this.triggerMethod('group:type-change', ev.currentTarget.value)
  },
  templateContext: function () {
    return {
      getDeviceTypes: App.TemplateHelpers.getDeviceTypes
    }
  }
})

// -- Dialog Layout ---------------------------
var dialogView = DialogComponent.Layout.extend({
  className: 'dialog dialog-client-edit',
  onRender: function () {
    var bodyView = new dialogBody({model: this.model, collection: this.collection})
    this.showChildView('bodyRegion', bodyView)
  },
  onLala: function (message) {
    console.log('A child view fired show:message with ' + message);
  },
})

module.exports.Layout = dialogView



// WEBPACK FOOTER //
// ./js/modules/groups/edit-new/view.js